import React from 'react'
// @ts-ignore
import { Sunburst } from '@netbasequid/chart'
import { useDisplayTheme } from 'hooks/useUiState'
import { SunburstProps } from './types'

const SunburstChart = ({ data, unit = '', onClick }: SunburstProps) => {
  const theme = useDisplayTheme()

  return <Sunburst data={data} unit={unit} mode={theme} onClick={onClick} />
}

export default SunburstChart
